import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";

export const getRemainingChangeRequestStatuses = (currentChangeRequestStatus: ChangeRequestStatusTypes) => {
    const changeRequestStatuses = [
        ChangeRequestStatusTypes.UNSUBMITTED,
        ChangeRequestStatusTypes.SUBMITTED,
        ChangeRequestStatusTypes.UNDER_REVIEW,
        ChangeRequestStatusTypes.APPROVED,
        ChangeRequestStatusTypes.DEPLOYED
    ];

    let currentStepIndex: number = null;

    const remainingChangeRequestStatuses = changeRequestStatuses.filter((status, index) => {
        if (status === currentChangeRequestStatus) {
            currentStepIndex = index;
        }

        if (currentStepIndex !== null && index > currentStepIndex) {
            return true;
        }

        return false;
    });

    return remainingChangeRequestStatuses;
};